import { StrategicAxesRepository } from "./adapters/repository";

import * as retrieveStrategicAxes from "./useCases/retrieveStrategicAxes";
import * as createStrategicAxis from "./useCases/createStrategicAxis";
import * as removeStrategicAxis from "./useCases/removeStrategicAxis";
import * as editStrategicAxis from "./useCases/editStrategicAxis";
import * as createProjectStrategicAxis from "./useCases/createProjectStrategicAxis";
import * as retrieveProjectStrategicAxes from "./useCases/retrieveProjectStrategicAxes";
import * as editProjectStrategicAxis from "./useCases/editProjectStrategicAxis";

enum UseCases {
  retrieveStrategicAxes = "retrieveStrategicAxes",
  createStrategicAxis = "createStrategicAxis",
  removeStrategicAxis = "removeStrategicAxis",
  editStrategicAxis = "editStrategicAxis",
  createProjectStrategicAxis = "createProjectStrategicAxis",
  retrieveProjectStrategicAxes = "retrieveProjectStrategicAxes",
  editProjectStrategicAxis = "editProjectStrategicAxis",
}

interface Core {
  [UseCases.retrieveStrategicAxes]: retrieveStrategicAxes.Interactor;
  [UseCases.createStrategicAxis]: createStrategicAxis.Interactor;
  [UseCases.removeStrategicAxis]: removeStrategicAxis.Interactor;
  [UseCases.editStrategicAxis]: editStrategicAxis.Interactor;
  [UseCases.createProjectStrategicAxis]: createProjectStrategicAxis.Interactor;
  [UseCases.retrieveProjectStrategicAxes]: retrieveProjectStrategicAxes.Interactor;
  [UseCases.editProjectStrategicAxis]: editProjectStrategicAxis.Interactor;
}

type Boundaries = BoundaryMap<Core>;

type Dependencies = {
  repository: StrategicAxesRepository;
};

function createCore(dependencies: Dependencies): Core {
  return {
    [UseCases.retrieveStrategicAxes]: retrieveStrategicAxes.createInteractor(
      dependencies.repository,
    ),
    [UseCases.createStrategicAxis]: createStrategicAxis.createInteractor(
      dependencies.repository,
    ),
    [UseCases.removeStrategicAxis]: removeStrategicAxis.createInteractor(
      dependencies.repository,
    ),
    [UseCases.editStrategicAxis]: editStrategicAxis.createInteractor(
      dependencies.repository,
    ),
    [UseCases.createProjectStrategicAxis]:
      createProjectStrategicAxis.createInteractor(dependencies.repository),
    [UseCases.retrieveProjectStrategicAxes]:
      retrieveProjectStrategicAxes.createInteractor(dependencies.repository),
    [UseCases.editProjectStrategicAxis]:
      editProjectStrategicAxis.createInteractor(dependencies.repository),
  };
}

export type { Core, Boundaries, Dependencies };

export { UseCases, createCore };
